Vue.component('game-example', require('./games/GameExample.vue').default);
Vue.component('game-grand-jeu-de-noel-2024', require('./games/GameGrandJeuDeNoel2024.vue').default);
